import { render, staticRenderFns } from "./LSelect2.vue?vue&type=template&id=d138d4f0&"
import script from "./LSelect2.vue?vue&type=script&lang=js&"
export * from "./LSelect2.vue?vue&type=script&lang=js&"
import style0 from "vue-select/dist/vue-select.css?vue&type=style&index=0&lang=css&"
import style1 from "./LSelect2.vue?vue&type=style&index=1&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports